/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_D3dInputs */

const en_mk_sol_agensi_d3d = /** @type {(inputs: Mk_Sol_Agensi_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human work shifts from typing to choosing and improving — the part that is actually worth billing for.`)
};

const id_mk_sol_agensi_d3d = /** @type {(inputs: Mk_Sol_Agensi_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan manusia bergeser dari mengetik ke memilih dan memperbaiki — bagian yang memang bernilai untuk ditagihkan.`)
};

/**
* | output |
* | --- |
* | "Human work shifts from typing to choosing and improving — the part that is actually worth billing for." |
*
* @param {Mk_Sol_Agensi_D3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_d3d = /** @type {((inputs?: Mk_Sol_Agensi_D3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_D3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_d3d(inputs)
	return en_mk_sol_agensi_d3d(inputs)
});